import { render, staticRenderFns } from "./DebitCardRejectCard.vue?vue&type=template&id=10bae416&scoped=true"
import script from "./DebitCardRejectCard.vue?vue&type=script&lang=js"
export * from "./DebitCardRejectCard.vue?vue&type=script&lang=js"
import style0 from "./DebitCardRejectCard.vue?vue&type=style&index=0&id=10bae416&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bae416",
  null
  
)

export default component.exports